module.exports = __webpack_public_path__ + "static/media/maisa_01.96f7eb88.jpg";